"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TestVocationalService = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../../constants/environment");
const environment_enum_1 = require("../enum/environment.enum");
class TestVocationalService {
    constructor(ENV = environment_enum_1.ENVIRONMENT.DEV, key) {
        // getOnboardingCatModality = async (): Promise<catmodality[]> =>{
        //     const URL = `${API_URL_BASE}/${this.ENV}/onboarding/catmodality`;
        //     const response = await axios.get(URL, {headers:{'x-api-key':this.KEY}})
        //     return  (response.status===200)? Promise.resolve(response.data): Promise.reject(response.statusText);
        // }
        this.getInfoORM = async (body) => {
            const URL = `${environment_1.API_URL_BASE}/${this.ENV}/catalogs/catalogorm`;
            const response = await axios_1.default.post(URL, JSON.stringify(body), { headers: { 'x-api-key': this.KEY } });
            return (response.status === 200) ? Promise.resolve(response.data) : Promise.reject(response.statusText);
        };
        this.postTestVocationUser = async (body) => {
            let instance = axios_1.default.create({
                baseURL: `${environment_1.API_URL_BASE}/${this.ENV}`,
                timeout: 120000
            });
            // const URL = `${API_URL_BASE}/${this.ENV}/user/test-vocational`;
            // const response = await axios.post(URL, body, {headers:{'x-api-key':this.KEY}})
            const response = await instance.post('/user/test-vocational', body, { headers: { 'x-api-key': this.KEY } });
            //return  (response.status===200)? Promise.resolve(response): Promise.reject(response);
            return (response.status === 200) ? Promise.resolve(response) : Promise.resolve(response);
        };
        this.ENV = ENV;
        this.KEY = key;
    }
}
exports.TestVocationalService = TestVocationalService;
